import { Grid, Box } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getInosioTermsAndConditions, selectOnboardingApplicationState } from "../pmui/onboarding/sagas/pmonboardingSlice";

export default function TermsAndConditions() {
  const selectOnboardingState = useSelector(selectOnboardingApplicationState);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: getInosioTermsAndConditions.type });
  }, []);

  return (
    <Grid sx={{ p: 2, display: "flex", flexDirection: "column", background: "#FFFFFF", justifyContent: "center", alignItems: "center" }}>
      <Grid item xs={12} sm={10}>
        <Box
          id="terms-and-condition"
          sx={{
            pt: 6,
            lineHeight: "28px",
            fontFamily: "Work Sans",
            fontStyle: "normal",
          }}
        >
          <div dangerouslySetInnerHTML={{ __html: selectOnboardingState.contract.InosioTsCs.Text.replace(/<\/?html>|<\/?body>/g, '') }} />
        </Box>
      </Grid>
    </Grid>
  );
}
